import { AudioElement, type ImageElement, type VideoElement } from '@bynder-studio/render-core';

export enum ContentType {
    AUDIO = 'audio',
    IMAGE = 'image',
    VIDEO = 'video',
}

export type Props = {
    // for ContentSelectorModal
    type: ContentType;
    frameRate: number;
    resizableRange?: boolean;
    selectedObject: {
        element: ImageElement | VideoElement | AudioElement;
        duration?: number;
    };
    collectionId?: number;
    show?: boolean;
    handleSelectSource: (elem: any) => void;
    setShowAssetSelection?: (show: boolean) => void;
    isEditorPage: boolean;

    // for the rest of component
    testId: string;
    disabled: boolean;
    loading?: boolean;
    mediaSrc?: string;
    fileName?: string;
    isAlpha?: boolean;
    duration?: number;
};
